var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorStub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 817 156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.7 95.7c-1.8 0-2.7-2-1.5-3l.3-.3-2.8-2.5-.3.2c-1.2 1.1-3.4.3-3.4-1.3v-.3h-4v.3c0 1.6-2.2 2.4-3.4 1.3l-.3-.2-2.8 2.5.3.2c1.2 1.2.3 3.1-1.5 3.1h-.3v3.6h.3c1.8 0 2.7 2 1.5 3l-.3.3 2.8 2.5.3-.2c1.2-1.1 3.4-.3 3.4 1.3v.3h4v-.3c0-1.6 2.2-2.4 3.4-1.3l.3.2 2.8-2.5-.3-.2c-1.2-1.2-.3-3.1 1.5-3.1h.3v-3.6h-.3ZM110 102c-2.8 0-5-2-5-4.5s2.2-4.5 5-4.5 5 2 5 4.5-2.2 4.5-5 4.5Z",
    fill: "#EB4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132 50c0 8.1-3 15.1-12.5 15.1H47c-9.9 0-15 6.4-15 16.9 0 7 5 15.3 15 15.2 18.2.9 35 .1 53.2.1",
    stroke: "#EB4D4D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M119.3 97.8h40.5",
    stroke: "#EB4D4D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164 99.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 2a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
    fill: "#EB4D4D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M645.7 98.8c-1.8 0-2.7 2-1.5 3l.3.3-2.8 2.5-.3-.2c-1.2-1.1-3.4-.3-3.4 1.3v.3h-4v-.3c0-1.6-2.2-2.4-3.4-1.3l-.3.2-2.8-2.5.3-.2c1.2-1.2.3-3.1-1.5-3.1h-.3v-3.6h.3c1.8 0 2.7-2 1.5-3l-.3-.3 2.8-2.5.3.2c1.2 1.1 3.4.3 3.4-1.3V88h4v.3c0 1.6 2.2 2.4 3.4 1.3l.3-.2 2.8 2.5-.3.2c-1.2 1.2-.3 3.1 1.5 3.1h.3v3.6h-.3Zm-9.7-6.3c-2.8 0-5 2-5 4.5s2.2 4.5 5 4.5 5-2 5-4.5-2.2-4.5-5-4.5Z",
    fill: "#EB4D4D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M618 97h8",
    stroke: "#EB4D4D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M646 97h8",
    stroke: "#EB4D4D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M658 95a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm0-2a4 4 0 1 1 0 8 4 4 0 0 1 0-8Z",
    fill: "#EB4D4D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M615 95a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm0-2a4 4 0 1 1 0 8 4 4 0 0 1 0-8Z",
    fill: "#EB4D4D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143 24.8 89.6 0l3.2 14.3L82 31.4h13.8a1 1 0 1 0 0-2h-8.3l8.7-7.2 6 23.2L143 24.9h.2-.1l-.2-.1Zm-17.4-2a1717.5 1717.5 0 0 1-31.3-7.1L87 27.2l9.5-7.8 29.1 3.4Zm-2-2.5a882 882 0 0 1-28.9-6.6L92.4 3.5l40.2 18.7-9-1.9Zm-20.1 22.2-5.4-21 38.3 4.5-33 16.5Z",
    fill: "#EB4D4D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4 133.2s3.8-3 6.2-3.7c2.3-.6 6.3.7 7.7 2.7a12 12 0 0 1 2.3 7.6c0 4.1-3 8.9-7.6 8.9H10.3c-.5 0-3-.4-4.5-1.5A8.7 8.7 0 0 1 3.6 135c1.4-2 4.7-2.8 5.8-2.8H11v-2c.9-5.8 7.6-8.2 12.7-8.2 2.5 0 4.9.3 7 1.7a11 11 0 0 1 4 5.6",
    stroke: "#EB4D4D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M799.4 139.2s3.8-3 6.2-3.7c2.3-.6 6.3.7 7.7 2.7a12 12 0 0 1 2.3 7.6c0 4.1-3 8.9-7.6 8.9h-28.7c-.5 0-3-.4-4.5-1.5a8.7 8.7 0 0 1-2.2-12.2c1.4-2 4.7-2.8 5.8-2.8h1.6v-2c.9-5.8 7.6-8.2 12.7-8.2 2.5 0 4.9.3 7 1.7a11 11 0 0 1 4 5.6",
    stroke: "#EB4D4D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M637.4 21.2s3.8-3 6.2-3.7c2.3-.6 6.3.7 7.7 2.7a12 12 0 0 1 2.3 7.6c0 4.1-3 8.9-7.6 8.9h-28.7c-.5 0-3-.4-4.5-1.5a8.7 8.7 0 0 1-2.2-12.2c1.4-2 4.7-2.8 5.8-2.8h1.6v-2c.9-5.8 7.6-8.2 12.7-8.2 2.5 0 4.9.3 7 1.7a11 11 0 0 1 4 5.6",
    stroke: "#EB4D4D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M719.5 115h-42.3c-1.2 0-2.2-1.1-2.2-2.3V55c0-1.2 1-2.2 2.2-2.2h11",
    stroke: "#EB4D4D",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M682.8 67.5h5.5",
    stroke: "#EB4D4D",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M682.8 77.7h5.5",
    stroke: "#EB4D4D",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M682.8 85.6h5.5",
    stroke: "#EB4D4D",
    strokeWidth: 2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M682.8 95.7h5.5",
    stroke: "#EB4D4D",
    strokeWidth: 2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M682.8 102.5h5.5",
    stroke: "#EB4D4D",
    strokeWidth: 2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M711.7 105.9h-21.1c-1.3 0-2.3-1-2.3-2.3V47.3c0-1.3 1-2.3 2.3-2.3H717l18 15.9v21.4",
    stroke: "#EB4D4D",
    strokeWidth: 2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M735 61.8h-15.5c-1.2 0-2.2-1-2.2-2.3V46.1",
    stroke: "#EB4D4D",
    strokeWidth: 2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M696.1 59.7h14.5",
    stroke: "#EB4D4D",
    strokeWidth: 2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M696.1 69.8h31.2",
    stroke: "#EB4D4D",
    strokeWidth: 2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M696.1 77.7h31.2",
    stroke: "#EB4D4D",
    strokeWidth: 2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M696.6 87h15.7",
    stroke: "#EB4D4D",
    strokeWidth: 2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M696.6 95.5h15.7",
    stroke: "#EB4D4D",
    strokeWidth: 2
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M717.7 84.1c-.7.7-.7 1.9 0 2.6L728 96.8l-10.2 10.1a1.8 1.8 0 1 0 2.6 2.6l10.1-10.2 10.1 10.2a1.8 1.8 0 1 0 2.6-2.6L733 96.8l10.2-10.1a1.8 1.8 0 1 0-2.6-2.6l-10 10.2L720.2 84c-.7-.7-1.9-.7-2.6 0Z",
    fill: "#EB4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorStub);
export default ForwardRef;